// Setting to false by default: Small coordinate/radius adjustments on-site
// must NOT invalidate physical printed paper QR codes.
// Validation is strictly handled server-side via worker's live GPS.
export const ENABLE_QR_OUTDATED_CHECK = false;
